import React, { useEffect, useState, useCallback } from "react";
import { getRevisionHistory } from "../../api/adminApi";

function formatDateTime(value) {
  if (!value) return "-";

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;

  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
  }).format(d);
}

export default function RevisionHistoryAdmin({ documentId, onOpen }) {
  const [revisions, setRevisions] = useState([]);

  const load = useCallback(async () => {
    const res = await getRevisionHistory(documentId);
    setRevisions(res.data);
  }, [documentId]);

  useEffect(() => {
    if (!documentId) return;
    load();
  }, [documentId, load]);

  return (
    <div className="card">
      {revisions.length === 0 ? (
        <div className="empty-state">No revisions available.</div>
      ) : (
        <div className="revision-list">
          {revisions.map((rev, index) => (
            <div key={rev.id} className="revision-item">
              <div>
                <div style={{ fontWeight: 700 }}>Revision {rev.revisionNo}</div>

                <div style={{ marginTop: 6 }}>
                  <span
                    className={`badge badge-${String(rev.status).toLowerCase()}`}
                  >
                    {rev.status}
                  </span>
                </div>

                <div className="helper-text" style={{ marginTop: 6 }}>
                  Created: {formatDateTime(rev.createdAt)}
                </div>
              </div>

              <button className="btn btn-light" onClick={() => onOpen(rev)}>
                Open
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
